const SET_CREATORS = (state, payload) => {
  state.creators = payload;
}

export default {
  SET_CREATORS
}